/* eslint 'jsx-a11y/alt-text': 'off', 'no-sequences':'off' */
import React, { Component } from "react";
import { connect } from "react-redux";
import { Redirect } from 'react-router-dom';
import { Modal } from 'reactstrap';
import { GetEmployeeLoginLogo } from 'action/facilitiesAction';
import { authenticateUser } from 'action/authenticateUser';
import { GetInvoiceLogo } from 'action/invoiceAction';
import EmployeeLicenseTerms from '../../common/Modals/EmployeeLicenseTerms';
import bottomlogo from 'Assets/images/darkgreen-trane-BA-logo.svg';
import 'Assets/styles/login.css';
import 'Assets/styles/layout.css';
import styles from './login.module.css';
import { setAmplitudeEvent,sendSingleAmplitudeEvent,identityCall } from 'amplitude/amplitude';
import { getServerType } from 'action/Administration/license';
import {GetApplicationVersion} from 'action/Administration/administrationAction';

let IsAuthenticate;
let username_req = "ID is required";
let password_req = "Password is required";
//let invalid_msg = "Invalid User ID or password";
//let UnAuthorised_Error_Msg = "UnAuthorised. Security Permissions for this user may have been changed. Contact your Administrator";


class FacilityLogin extends Component {

    componentWillMount() {
       this.props.getServerType("FM");
       IsAuthenticate = false;
       this.props.GetApplicationVersion();
       this.props.GetInvoiceLogo();
       localStorage.setItem("facility_page_to_display",null);
    }

    componentWillReceiveProps(nextProps) {

        if (this.props !== nextProps) {
            if(nextProps.Version !== "" && this.props.Version !== nextProps.Version ){
                this.setState({application_version:nextProps.Version});
            }
             if(nextProps.loginlogo_response != null){
                 this.setState({
                    imagePreviewUrl: nextProps.loginlogo_response.Invoicelogo
                });
             }
             if(nextProps.login_response !== null && IsAuthenticate === true){
                this.setState({
                    loggedIn: nextProps.login_response.loggedIn,
                    token: nextProps.login_response.token,
                    user_type: nextProps.login_response.user_type,
                    error_msg: false, error_msg_type:null, 
                });

     //API not responding
           if ('API_not_responding' in nextProps.login_response) {
           if (nextProps.login_response.API_not_responding === true) {
              this.setState({
                  error_msg: true,
                  error_msg_type: "Error: Cannot Connect to Facility Service. Verify Whether Service is Running.",
              });
          }
      }

      
      if(nextProps.login_response.ErrorStatus === 404 && nextProps.login_response.invalid_user === false){
        this.setState({
            error_msg: true,
            error_msg_type: "Error: UnAuthorised. Security Permissions for this user may have been changed. Contact your Administrator.",
        },()=>{setAmplitudeEvent("Logged_In",{"error type":"UnAuthorised. Security Permissions for this user may have been changed. Contact your Administrator"}) });
         }

      if(nextProps.login_response.invalid_user === true){
        this.setState({
            error_msg: true,
            error_msg_type: "Error: Invalid User ID or password.",
        },()=>{setAmplitudeEvent("Logged_In",{"error type":"invalid credentials"}) });
         }

        }

        }
    }

    authenticate = (e) => {
        e.preventDefault();
        IsAuthenticate = true;
        let {username,password} = this.state;
        // this.setState({isUsernameEmpty: false, isPasswordEmpty: false, username_req: null, password_req: null, error_msg:false});
        if(username !== null && password !== null && username !== "" && password !== ""){
            let credentials= {
                "username":username,
                "password":password,
                "login_type":"tenant_employee"
            }
            this.props.authenticateUser(credentials);
        }
        else{
            if(username === null || username === "" || username === undefined){
                this.setState({isUsernameEmpty: true, error_msg: false},()=>{ setAmplitudeEvent("Logged_In",{"error type":"username empty"})});
            }
            if(password === null || password === "" || password === undefined){
                this.setState({isPasswordEmpty: true, error_msg: false},()=>{setAmplitudeEvent("Logged_In",{"error type":"password empty"})});
            }
        }
    }

    constructor(props) {
        super(props);
        this.state = {
            redirect:false,
            inputValue:'' ,
            error_msg:false,
            isUsernameEmpty: false,
            isPasswordEmpty: false,
            error_msg_type:null,
            license_modal: false,
            image_name: '',
            imagePreviewUrl: '',
            username:null,
            password:null,
            token:null,
            loggedIn:null,
            user_type:null,
        };
        this.toggle = this.toggle.bind(this);
        this.setAmplitude = this.setAmplitude.bind(this);
    }

    toggle() {
        this.setState({
            license_modal: !this.state.license_modal
        });
    }

    CloseModal = (someArg) => {
        if (someArg === "Cancel") {
            this.toggle()
        }
    }

    setAmplitude(){
        var eventProperties ={
            "userID":localStorage.getItem("TenantUserID"),
            "userRole":"tenant employee",
            "client":"facilty request",
            "version":this.state.application_version,
        }
        identityCall(eventProperties);
         sendSingleAmplitudeEvent("Logged_In");
    }

    render() {
        let id=0;
        let {imagePreviewUrl,token,loggedIn,user_type} = this.state;

        if((token !==null,loggedIn ===true,user_type ==="tenant_employee")){
            if (this.props.UserName_response !== undefined && this.props.UserName_response !== null) {
                id = this.props.UserName_response.tenantUserId;
            }
            this.setAmplitude();
            return <Redirect to={{ pathname: '/FacilityManagement/home', state: {tenantUserId:id}}}/>
        }

        let $imagePreview = null;
         (imagePreviewUrl)? $imagePreview = (<img src={imagePreviewUrl}  className={styles.facility_logo_image}/>)  :  $imagePreview = ("");

        return (
            <div className={styles.loginContainer}>
                 <div className={styles.desktop_login_image}>
                    <div className={styles.login_header_mobile}>Facility Request</div>
                    <h1 className={styles.text}>FACILITY REQUEST</h1>
                    <img src={bottomlogo} alt="Missing Logo" className={styles.bottom_logo}/>
                    <div className={styles.login_form_container}>
                        <form className={styles.login_form} onSubmit={(e)=>this.authenticate(e)}>

                        {/* dynamic logo */}
                            {$imagePreview}

                        {/* Login title */}
                            <h1 className={styles.login_title}>Log in to Facility Request</h1>

                        {/* Login username */}
                            <div className={styles.login_group}>
                                <label className={(!this.state.isUsernameEmpty && !this.state.error_msg) ? styles.login_field_label : styles.login_field_error}>User ID*</label>
                                <input id="txt_UserID" type="text" className={(!this.state.isUsernameEmpty && !this.state.error_msg) ? styles.loginbox : styles.login_errorbox} onChange={(e) => this.setState({username: e.target.value})}/>
                                {(this.state.isUsernameEmpty) ? <span style={{color:'#D42D27',fontFamily:'lato',fontSize:'10px',fontStyle:'italic',fontWeight:'bold'}}>{username_req} </span>
                                 : (this.state.error_msg) ? <span style={{color:'#D42D27',fontFamily:'lato',fontSize:'10px',fontStyle:'italic',fontWeight:'bold'}}>{this.state.error_msg_type} </span> : ""}
                            </div>

                        {/* Login password */}
                            <div className={styles.login_group}>
                                <label className={(!this.state.isPasswordEmpty  && !this.state.error_msg) ? styles.login_field_label : styles.login_field_error}>Password*</label>
                                <input id="txt_Password" type="password" className={(!this.state.isPasswordEmpty  && !this.state.error_msg) ? styles.loginbox : styles.login_errorbox}  onChange={(e) => this.setState({password: e.target.value})} />
                                {(this.state.isPasswordEmpty) ? <span style={{color:'#D42D27',fontFamily:'lato',fontSize:'10px',fontStyle:'italic',fontWeight:'bold'}}>{password_req} </span>
                                 : (this.state.error_msg) ? <span style={{color:'#D42D27',fontFamily:'lato',fontSize:'10px',fontStyle:'italic',fontWeight:'bold'}}>{this.state.error_msg_type} </span> : ""}
                            </div>

                            <label style={{color:'grey',fontSize:'10px',fontFamily:'lato'}}><i>*required fields</i></label>

                        {/* Copyright info */}
                         <p className={styles.login_copyright_text} >By accessing Trane Facility Services, you accept and agree to <br/>be bound by the
                         <span className={styles.copyright_nav}  onClick={this.toggle}> End-User License Agreement Terms and <br/> Conditions.</span></p>


                        {/* Login button */}
                         <button id="btn_LogIn" type="submit" className={styles.login_btn} onClick={(e)=>this.authenticate(e)}>LOG IN</button>
                         </form>

                    </div>
                 </div>
                 <Modal isOpen={this.state.license_modal} toggle={this.toggle} className="emp_license_modal">
                    <EmployeeLicenseTerms CloseModal={this.CloseModal} />
                </Modal>
            </div>
        );
    }
}

const mapStateToProps = state => {
    return {
    userProfileDetails: state.userDetailsRootReducer,
    loginlogo_response: state.InvoiceRootReducer,
    login_response: state.authService,
    Version: state.InstallationsRootReducer.ApplicationVersion,
    error_reponse: state.errorResponse

    };
  };

const mapDispatchToProps = dispatch => {
    return {
        getServerType: (featureName) => dispatch(getServerType(featureName)),
        authenticateUser: (credentials) => dispatch(authenticateUser(credentials)),
        GetEmployeeLoginLogo: () => dispatch(GetEmployeeLoginLogo()),
        GetInvoiceLogo: () => dispatch(GetInvoiceLogo()),
        GetApplicationVersion: () => dispatch(GetApplicationVersion())
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(FacilityLogin);